<script setup>
import traiteurDeFetePopin3 from "@/assets/images/traiteur/traiteur-de-fete-popin-3.svg";
import traiteurDeFetePopin2 from "@/assets/images/traiteur/traiteur-de-fete-popin-2.svg";
import traiteurDeFetePopin1 from "@/assets/images/traiteur/traiteur-de-fete-popin-1.svg";
defineEmits("closed");
</script>
<script>
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import Badge from "@/components/atoms/badge";
import Divider from "@/components/atoms/divider";
import Titre from "@/components/atoms/titre";
import Card from "@/components/molecules/card";
import LazyImage from "@/components/atoms/lazy-image";
import GridRow from "@/components/molecules/grid/grid-row";
import GridCol from "@/components/molecules/grid/grid-col";
import Container from "@/components/atoms/container";

export default {
  name: "PopinConfirmationMagasin",
  components: {
    Popin,
    Icon,
    Button,
    Badge,
    Titre,
    Card,
    LazyImage,
    Divider,
    GridRow,
    GridCol,
    Container
  },

  props: {
    showPlanningClickCollectTraiteur: {
      type: Boolean,
      required: true
    },
    traiteurDeFetesCategorySlug: {
      type: String,
      required: true
    }
  },
  methods: {
    isSameRoute(path) {
      const {
        currentRoute: { fullPath: curPath }
      } = this.$router;
      return curPath === path;
    },
    handleClick() {
      if (this.traiteurDeFetesCategorySlug) {
        if (this.isSameRoute(this.traiteurDeFetesCategorySlug)) {
          this.$router.go();
        }
        navigateToInternal(this.traiteurDeFetesCategorySlug);
      }
    }
  }
};
</script>

<template>
  <Popin
    :visible="showPlanningClickCollectTraiteur"
    size="lg"
    aria-label="Traiteur de fêtes"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    @closed="$emit('closed')"
  >
    <Container size="xs">
      <div class="u-text-center u-font-16 u-mb-lg25">
        <Badge
          circle
          variant="golden"
          size="xxxlg"
          class="u-mb-xs25"
        >
          <Icon
            variant="white"
            name="traiteur"
            size="lg"
          />
        </Badge>

        <Titre
          tag="h1"
          variant="primary"
          class="u-mb-xs25"
        >
          Simplifiez-vous les fêtes !
        </Titre>
        <p class="u-font-16 u-mb-md">
          Commandez votre traiteur en ligne dès maintenant.
          <br>
          Retirez votre commande au moment des fêtes.
        </p>
        <Card
          variant="bg"
          radius="md"
          class="u-text-left u-py-sm u-px-md u-mb-lg"
        >
          <div class="u-mb-sm">
            <p class="u-font-16 u-font-700">
              <strong>Pour Noël</strong>
            </p>
            <p class="u-font-16">
              • Commandez avant le 17 Décembre à 12h00 / Retirez votre commande le 23 ou le 24 Décembre
            </p>
          </div>
          <div>
            <p class="u-font-16 u-font-700">
              <strong>Pour le réveillon</strong>
            </p>
            <p class="u-font-16">
              • Commandez avant le 23 Décembre à 12h00 / Retirez votre commande le 30 ou le 31 Décembre
            </p>
          </div>
        </Card>
        <GridRow class="u-flex-align-center u-flex-column-reverse@sm">
          <GridCol sm="12">
            <LazyImage
              :src="traiteurDeFetePopin1"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">1</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je commande et je règle mon traiteur à l'avance
                </Titre>
                <p>sur le site cora.fr</p>
              </div>
            </div>
          </GridCol>
        </GridRow>

        <Divider
          dotted
          class="u-my-lg"
        />

        <GridRow class="u-flex-align-center">
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">2</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je programme mon retrait de commande
                </Titre>
                <p>le jour qui me convient le mieux : le 23, 24, 30 ou 31 Décembre</p>
              </div>
            </div>
          </GridCol>
          <GridCol sm="12">
            <LazyImage
              :src="traiteurDeFetePopin2"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
        </GridRow>

        <Divider
          dotted
          class="u-my-lg"
        />

        <GridRow class="u-flex-align-center u-flex-column-reverse@sm u-mb-xlg">
          <GridCol sm="12">
            <LazyImage
              :src="traiteurDeFetePopin3"
              width="250"
              class="u-flex-item-none"
            />
          </GridCol>
          <GridCol
            sm="12"
            class="u-mb-sm@sm"
          >
            <div class="u-flex">
              <Badge
                circle
                size="lg"
                variant="primary"
                class="u-mr-xs25 u-flex-shrink-none"
              >
                <strong class="u-font-secondary u-font-20">3</strong>
              </Badge>
              <div class="u-text-left">
                <Titre
                  tag="h2"
                  size="md"
                  variant="primary"
                >
                  Je récupère ma commande au moment des Fêtes
                </Titre>
                <p>en quelques minutes</p>
              </div>
            </div>
          </GridCol>
        </GridRow>

        <Button
          variant="secondary"
          radius="full"
          size="md"
          @click="handleClick()"
        >
          Voir la sélection Traiteur de Fêtes
        </Button>
      </div>
    </Container>
  </Popin>
</template>

<style lang="scss" scoped>
</style>
